module.exports = __webpack_public_path__ + "231ef82653d90aa19929e7dcd84c55c7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/uikit/assets/font/noto-sans-kr-v11-korean_latin-regular.woff
// module id = 457
// module chunks = 0